import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InvoiceAddLayer from "../components/InvoiceAddLayer";
import { useParams } from "react-router-dom";
import JobInvoiceLayer from "./JobInvoiceLayer";
import { API_URL } from "..";



const JobInvoicePage = () => {
    const {id} = useParams();
    const [data,setData] = useState({})
    // const 
    useEffect(()=>{
          const fetchUser = async()=>{
            let headerList = {
                "Accept": "*/*",
                "Content-type": "application/json",
              };
              const response = await fetch(
                API_URL+`/api/job/fetch-single/${id}`,
                { method: "GET", headers: headerList }
              );
              const data = await response.json();
              if (response.status === 200) {
                  setData(data.job)
              }
            };
            fetchUser();
    },[])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Order Form - Add" />

        {/* InvoiceAddLayer */}
        <JobInvoiceLayer jobId={id}/>

      </MasterLayout>

    </>
  );
};

export default JobInvoicePage;
